/**
 * Returns the correct API base URL.
 * On custom domains (e.g. fundlebrain.fundledata.com), uses same-origin
 * to avoid cross-origin cookie issues. On preview/dev, uses REACT_APP_BACKEND_URL.
 */
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    const isPreview = origin.includes('emergentagent.com') || origin.includes('emergent.host');
    const isDev = origin.includes('localhost');
    if (!isPreview && !isDev) {
      return origin;
    }
  }
  return envUrl;
};

export const API_BASE_URL = getApiUrl();
